import axios from "../Assets/Lib/axios";

const analyticsApi = {
  // General Summary
  getSummary: (params) =>
    axios.get("/analytics/summary", { params }),

  // Revenue Analytics
  getRevenueSummary: (params) =>
    axios.get("/analytics/revenue/summary", { params }),

  getRevenueByProduct: (params) =>
    axios.get("/analytics/revenue/by-product", { params }),

  getRevenueByPaymentMethod: (params) =>
    axios.get("/analytics/revenue/by-payment-method", { params }),

  getRevenueTrend: (params) =>
    axios.get("/analytics/revenue/trend", { params }),

  // Customer Analytics
  getCustomersSummary: (params) =>
    axios.get("/analytics/customers/summary", { params }),

  getRepeatCustomers: (params) =>
    axios.get("/analytics/customers/repeat", { params }),

  getCustomerLTV: (params) =>
    axios.get("/analytics/customers/lifetime-value", { params }),

  getCustomerCohorts: (params) =>
    axios.get("/analytics/customers/cohorts", { params }),

  // Product Analytics
  getBestSellers: (params) =>
    axios.get("/analytics/products/best-sellers", { params }),

  getBestSellingCourses: (params) =>
    axios.get("/analytics/products/best-sellers/courses", { params }),

  getBestSellingLectures: (params) =>
    axios.get("/analytics/products/best-sellers/lectures", { params }),

  getBestSellingNotes: (params) =>
    axios.get("/analytics/products/best-sellers/notes", { params }),

  getProductsBySubject: (params) =>
    axios.get("/analytics/products/by-subject", { params }),

  getProductsByUniversity: (params) =>
    axios.get("/analytics/products/by-university", { params }),

  getEngagementMetrics: (params) =>
    axios.get("/analytics/products/engagement", { params }),

  getCourseEnrolledUsers: (courseId) =>
    axios.get(`/analytics/products/courses/${courseId}/enrolled-users`),

  getLectureEnrolledUsers: (lectureId) =>
    axios.get(`/analytics/products/lectures/${lectureId}/enrolled-users`),

  // Recent Activity
  getRecentSales: (params) =>
    axios.get("/analytics/recent-sales", { params }),
};

export default analyticsApi;
